<div *ngIf="!hideHeader" class="balloon-header" [style.border-color]="color">
  <img *ngIf="avatar" [src]="avatar" class="balloon-header__avatar" (error)="onAvatarError()" />
  <div class="balloon-header__info">
    <div *ngIf="title" class="balloon-header__title">
      <span class="balloon-header__title__text">{{ title }}</span>
      <mat-icon
        *ngIf="showEVTag"
        fmTooltip="Electric Vehicle"
        i18n-fmTooltip="@@S_ELECTRIC_VEHICLE_TOOLTIP"
        svgIcon="ic-electric-vehicle-badge"
        class="balloon-header__title__electric-vehicle-icon mat-icon-size-xs"
      ></mat-icon>
      <mat-icon
        *ngIf="showCriticalHealth"
        svgIcon="ic-health-status-critical"
        fmTooltip
        [fmTooltipTemplate]="vehicleDeviceHealthStatusToolTip"
        class="balloon-header__title__electric-vehicle-icon mat-icon-size-xs"
        a7s-id="live-map-balloon-header-vehicle-issue-badge-icon-hover"
      >
      </mat-icon>
    </div>
    <span *ngIf="subtitle" class="balloon-header__subtitle">{{ subtitle }}</span>
    <ng-content></ng-content>
  </div>
</div>
<div *ngIf="hideHeader" class="balloon-header-empty"></div>
<ng-template #vehicleDeviceHealthStatusToolTip>
  <div class="health-status-tooltip-container" *ngIf="showCriticalHealth">
    <fm-health-status-tooltip [deviceHealthStatus]="deviceHealthStatus" [deviceType]="deviceType"></fm-health-status-tooltip>
  </div>
</ng-template>
